import { Box } from "@mui/material";
import { FC, useState } from "react";
import { H3, H4, H5, Small } from "../../components/Typography";
import CustomButton from "../../components/CustomButton";
import { useNavigate, useLocation } from "react-router-dom";

import { Player } from "@lottiefiles/react-lottie-player";
import Success from "../../assets/Lottifies/sucessPayment.json";

const SellSuccess: FC = () => {
  let navigate = useNavigate();
  let routeData = useLocation();
  const { amount } = routeData.state;

  return (
    <Box
      sx={{
        background: "#F6F6F6",
        pl: {
          md: 10,
          xs: 2,
          sm: 2,
        },
        pr: {
          md: 10,
          xs: 2,
          sm: 2,
        },
        pb: 2,
        pt: 2,
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
      }}
      height={"100vh"}
    >
      <Player
        autoplay
        loop
        src={Success}
        style={{ height: "300px", width: "300px" }}
      />
      <H3
        sx={{
          fontFamily: "'Poppins', sans-serif",
          width: {
            md: "40%",
            xs: "90%",
          },
          pt: 2,
          textAlign: "center",
        }}
      >
        Your sell transaction is successful.
      </H3>
      <Box
        sx={{
          border: "0.5px solid rgba(255, 239, 236, 0.5)",
          borderRadius: "12px",
          background: "#ffff",
          width: {
            md: "30%",
            xs: "90%",
          },
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          mt: 1.5,
          mb: 1,
          pt: 2,
          pb: 2,
        }}
      >
        <H4
          fontSize={14}
          fontWeight={"700"}
          sx={{
            fontFamily: "'Poppins', sans-serif",
            pt: 2,
            pb: 0,
          }}
        >
          Amount to be credited in account
        </H4>
        <Small
          sx={{
            mt: 0.4,
            fontSize: 22,
            textAlign: {
              md: "left",
              xs: "center",
            },
          }}
          fontWeight={"600"}
          color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
        >
          ₹
          <Small
            sx={{
              mt: 0.4,
              fontFamily: "'Poppins', sans-serif",
              fontSize: 22,
            }}
            fontWeight={"600"}
            color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
          >
            {amount}
          </Small>
        </Small>
      </Box>
      <H5
        fontSize={12}
        fontWeight={"400"}
        sx={{
          fontFamily: "'Poppins', sans-serif",
          pt: 0.5,
          pb: 2,
          color: "#595959",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          width: {
            md: "30%",
            xs: "90%",
          },
          textAlign: "center",
        }}
      >
        Note: We assure your amount will be credited to your bank account within
        24 to 48 hours.
      </H5>
      <CustomButton
        title="Back to Home"
        onPress={() => navigate("/dashboard")}
        width={"30%"}
        sWidth={"90%"}
      />
    </Box>
  );
};

export default SellSuccess;

